export default __webpack_public_path__ + "static/media/icon-mikstur.4ff2d7cb.svg";